import React, {useState, useEffect} from "react";
// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";
import Header from "../components/Header";
import {Link} from "react-router-dom";

import "./services.css";
export default function Services(){

    const [services, setServices] = useState([]);

    useEffect(() => {
        fetch('https://oculus-api.onrender.com/api/services')
            .then(res => res.json())
            .then(data => setServices(data))
            .catch(err => console.error('Error fetching services: ', err))
    }, []);

    const [openFaqIndex, setOpenFaqIndex] = useState(null);
    const toggleFaq = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
    };
    const faqs = [
    {
      question: "How do I book an appointment?",
      answer: "You can book an appointment by calling our hotline or using the 'Book Appointment' button on the top right corner of this page."
    },
    {
      question: "Do you accept health insurance?",
      answer: "Yes, we partner with most major insurance providers. Please visit our Patient Info page for a full list of accepted plans."
    },
    {
      question: "What are your clinic hours?",
      answer: "We are open Monday through Friday from 8:00 AM to 8:00 PM, and on Saturdays from 9:00 AM to 5:00 PM."
    },
    {
      question: "Is emergency care available?",
      answer: "Yes, we have a 24/7 emergency response team. For life-threatening emergencies, please dial 108 immediately."
    }
    ];
    return(
        <div>
            <Header/>
            <div className="services-page">
                <div className="services-container">
                    <div className="services-header">
                        <h1>Clinical Excellence</h1>
                        <p>Explore our comprehensive range of medical specialties and advanced treatments.</p>
                    </div>
                    <div className="service-grid">
                        {services.map((service) => (
                            <Link 
                                to={`/services/${service._id}`}
                                key={service._id}
                                className="service-grid-card"
                            >
                                <div className="card-content">
                                    <h3>{service.title}</h3>
                                    <span className="arrow-icon">→</span>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
                <div className="faq-section">
                    <h2>Frequently Asked Questions</h2>
                    <div className="faq-list">
                        {faqs.map((faq, index) =>(
                            <div key={index} 
                                className={`faq-item ${openFaqIndex === index ? "open" : ""}`}
                                onClick={() => toggleFaq(index)}
                            >
                                <div className="faq-question">
                                    <h3>{faq.question}</h3>
                                    <button className="faq-toggle-btn">
                                        {openFaqIndex === index ? "-" : "+"}
                                    </button>
                                </div>
                                <div className="faq-answer">
                                    <p>{faq.answer}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {/* <Footer/> */}
        </div>
    );
}